import _ from 'underscore';
import template from './audience-decoration.pug';

function getEl(gridView) {
  const gridContainer = gridView.$el.closest('.bingadsgrid');

  return gridContainer.find('.editor__container');
}

export const onSuccess = ({ i18n, isCustomInMarketEnabled, audiencesPath }) => {
  const audienceLink = `<a class="aud-tab-link" href="${audiencesPath}">${i18n.getString('Remarketing_Tutorial_Step3_Desc_AudienceTabLink')}</a>`;
  const info = isCustomInMarketEnabled ?
    i18n.getString('Audiences_AssociationSuccess_Message_CustomInMarket_Campaign').replace('{0}', audienceLink) :
    i18n.getString('Audiences_AssociationSuccess_Message_Campaign').replace('{0}', audienceLink);
  window.App.views.alertCenter.toastInfo(info);
};

export function campaignAudienceAssociationDecoration(gridView, {
  i18n,
  isCustomInMarketEnabled,
}) {
  _.defer(() => {
    const stateData = window.App.state.get('$data');

    if (stateData && stateData.fromAudienceLibrary) {
      // Show the message on top of the grid view
      getEl(gridView).html(template({
        fromAudienceLibrary: true,
        isCustomInMarketEnabled,
        i18n,
      })).show();
    }

    // Setup handler of association success
    window.App.on('campaignRemarketingAssociated', (/* isBSCAdGroupFiltered, not used */) => {
      // Show the return link to audience tab
      const container = getEl(gridView);

      container.html(template({
        campaignRemarketingAssociated: true,
        isCustomInMarketEnabled,
        i18n,
      })).show();

      container.find('.aud-tab-link').click(() => {
        window.App.navigate('customer/:customer_id/account/:account_id/audiences');
      });
    });
  });
}
